export default class AdobeEvent {
  private eventData: any;

  constructor(eventName: string, eventDataName?: string, eventData?: object) {
    this.eventData = {
      event: eventName,
    };

    if (eventDataName) {
      this.eventData[eventDataName] = eventData;
    }
  }

  public getData(): any {
    return this.eventData;
  }
}
